var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _theme = _interopRequireDefault(require("./styles/theme"));

var _fontello = _interopRequireDefault(require("./styles/fonts/fontello.ttf"));

var _Basic = require("./Basic");

module.exports = {
  View: _Basic.View,
  ScrollView: _Basic.ScrollView,
  FlatList: _Basic.FlatList,
  Text: _Basic.Text,
  Title: _Basic.Title,
  Heading: _Basic.Heading,
  SubHeading: _Basic.SubHeading,
  Image: _Basic.Image,
  Row: _Basic.Row,
  Column: _Basic.Column,
  CenteringScreen: _Basic.CenteringScreen,
  RefreshControl: _Basic.RefreshControl,
  HyperText: _Basic.HyperText,
  theme: _theme.default,
  fontelloFont: _fontello.default
};